import { MainLayout } from '@/componentes/Layout/MainLayout'

export const TermsAndConditions = () => {
  return <MainLayout title="TODO">test</MainLayout>
}
